export {
  isXcodemakeEnabled,
  isXcodemakeAvailable,
  isXcodemakeBinaryAvailable,
  doesMakefileExist,
} from '../xcodemake.ts';
